<script>
import { computedPbxBasePlans, computedPbxPlans, PBX_SUB_TYPES } from '@/common/service/computers/plans/pbx';
import mixin from '@/plans/mx/shopping-cart';
import { plansof } from '@/utils/chain';
import { mapGetters } from 'vuex';
import { planTypes } from '@/common/constants';
import { logger } from '@/utils/log';

export default {
  mixins: [mixin],
  computed: {
    ...mapGetters(['getSelectedPlans']),
    selectedPbxPlans() {
      return computedPbxPlans(this.getSelectedPlans);
    },
    pbxAddonPlans() {
      return this.selectedPbxPlans.filter(item => [PBX_SUB_TYPES.FEATURE, PBX_SUB_TYPES.UNLIMITED_ADDON].includes(item.sub_type));
    },
    hasPbxCart() {
      return this.filterKeys.includes('ZOOM_PHONE');
    },
  },
  methods: {
    $renderCallingPlanContent(plan) {
      const { parent_category, category } = plan;
      const pbxCategoryCode = category.toUpperCase().replace(parent_category.toUpperCase(), '');
      let cartName = this.$t(`billing.pbx.cart_name.${pbxCategoryCode}`);
      if (pbxCategoryCode === 'ZSU') {
        cartName = this.$t('billing.pbx.plan_name.ZSU');
      }
      return (
        <div class="pbx-cart-part">
          {this.mx_subTitle(
            cartName,
            this.mx_price(plan),
            plan.plan_code
          )}
          {this.mx_discount(plan.plan_code)}
          {this.mx_license(plan.cartInfo.selected_number, this.$t('billing.planform.unit.user'))}
          {this.mx_cycle(plan.billing_cycle)}
          {this.mx_edit(plan)}
        </div>
      );
    },
    $renderCallingPlan() {
      const callingPlans = plansof(this.getSelectedPlans).type(planTypes.ZOOM_ONE_BUNDLE).get();
      if (!callingPlans.length) return;
      return callingPlans.map((plan) => this.$renderCallingPlanContent(plan));
    },
    $renderPbxBasePlan() {
      const pbxBasePlan = computedPbxBasePlans(this.getSelectedPlans)[0];
      if (!pbxBasePlan) return null;
      if (this.hasPbxCart) return null;
      return (
        <div class="pbx-cart-part">
          {this.mx_subTitle(this.$t('billing.pbx.calling_fee_name.pay_you_go.MC'), pbxBasePlan.amount, pbxBasePlan.plan_code)}
          {this.mx_discount(pbxBasePlan.plan_code)}
          {this.mx_cycle(pbxBasePlan.billing_cycle)}
          {this.mx_edit(pbxBasePlan)}
        </div>
      );
    },
    $renderPbxAddons() {
      if (!this.pbxAddonPlans?.length) return null;
      if (this.hasPbxCart) return null;

      logger.info("render pbx addon plan in pro plus context");

      return <div class="opc-cart-item">
        <h1 class="opc-cart-item__title text-capitalize">{this.$t('billing.planform.title.zoomphone')}</h1>
        {
          this.pbxAddonPlans.map(item => (
            <div class="pbx-cart-part" key={item.plan_code}>
              {this.mx_subTitle(this.$t(`billing.pbx.plan_name.${item.category}`), this.mx_price(item), item.plan_code)}
              {this.mx_discount(item.plan_code)}
              {this.mx_license(item.cartInfo.selected_number, this.$t('billing.planform.unit.number'))}
              {this.mx_cycle(item.billing_cycle)}
              {this.mx_edit(item)}
              {this.isShowRmvBtn && this.mx_remove(item)}
            </div>
          ))
        }
      </div>;
    },
    mergePlans (planList) {
      if(!Array.isArray(planList)) {
        return [];
      }
      return planList.reduce((acc, cur) => {
        if(Array.isArray(cur)) {
          return [...acc, ...cur];
        }
      }, [])
    },

    renderMainTitle () {
      const callingPlans = plansof(this.getSelectedPlans).type(planTypes.ZOOM_ONE_BUNDLE).get();
      const pbxBasePlan = computedPbxBasePlans(this.getSelectedPlans);
      const plans = this.mergePlans([callingPlans, pbxBasePlan]);
      return plans.map((item, index) => {
        if(!index) {
          return  this.mx_main_title(this.$t('billing.planform.title.zoom_one_biz_plus'), undefined, item.parent_category)
        }
        return <div style='display: none;'>{this.mx_main_title(this.$t('billing.planform.title.zoom_one_biz_plus'), undefined, item.parent_category)}</div>
      })
    },

    $renderPrice() {
      return (
        <div>
          <div class="opc-cart-item">
            {this.renderMainTitle()}
            {this.$renderCallingPlan()}
            {this.$renderPbxBasePlan()}
          </div>
          {this.$renderPbxAddons()}
        </div>
      );
    },
  },
};
</script>
<style lang="scss">
.pbx-cart-part {
  margin-bottom: 10px;
}
</style>
